<script lang="ts">
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>
        
        <div class="s20 widget px-6 pt-8 pb-2">
            <div class="s5 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Transactions
                </span>
            </div>
            <div class="s15 mt--5-5 flex-right">
                <div class="form-field-floating default sm s6_mobile ml-3">
                    <select class="form-input-select" name="pays" id="pays">
                        <option value="" selected>Toutes les collectivités</option>
                        <option value="">Ordre Décroissant</option>
                        <option value="">Ordre Croissant</option>
                        <option value="">De A - Z</option>
                        <option value="">De Z - A</option>
                    </select>
                </div>
                <button class="btn lg py-3 black">
                    <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                    <span>Exporter en PDF</span>
                </button>
                <button class="btn lg py-3 black ">
                    <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                    <span>Exporter en Excel</span>
                </button>
            </div>
            <div class="clear-both h-5"></div>

            <div class="s20 gap-6 px-4 pb-6 collapse-content active">
                <!--Frontoffice-->
                <!-- <div class="s13 flex gap-3 mb-5">
                    <span class="btn light">Janvier</span>
                    <span class="btn light2">Decembre</span>
                    <span class="btn light2">Novembre</span>
                    <span class="btn light2">Octobre</span>
                    <span class="btn light2">Septembre</span>
                </div> -->
                <div class="s20 flex gap-3 mb-2">
                    <div class="form-field-split my-4">
                        <div class="form-field-floating reactive search sm">
                            <input type="text" class="form-input" name="date1" id="date1" placeholder="">
                            <label for="date1">Référence de transaction</label>
                        </div>
                    </div>
                    <div class="form-field-split my-4">
                        <div class="form-field-floating reactive sm">
                            <input type="date" class="form-input" name="date1" id="date1" placeholder="">
                            <label for="date1">Date &lt;=</label>
                        </div>
                        <hr class="hr sm" />
                        <div class="form-field-floating reactive sm">
                            <input type="date" class="form-input" name="date2" id="date2" placeholder="">
                            <label for="date2">Date &gt;=</label>
                        </div>
                    </div>
                    <div class="form-field-split my-4">
                        <div class="form-field-floating reactive sm">
                            <input type="time" class="form-input" name="time1" id="time1" placeholder="">
                            <label for="time1">Heure &lt;=</label>
                        </div>
                        <hr class="hr sm" />
                        <div class="form-field-floating reactive sm">
                            <input type="time" class="form-input" name="time1" id="time1" placeholder="">
                            <label for="time1">Heure &gt;=</label>
                        </div>
                    </div>
                </div>
                <div class="s20 flex gap-3 mb-5">
                    <span class="btn light">Tout</span>
                    <span class="btn light2">Wallet</span>
                    <span class="btn light2">Carte Orange Bank</span>
                </div> 

                <div class="s8">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2">- 10 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2">- 15 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2">- 5 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2">- 5 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement Wallet</h6>
                            <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2">- 5 000 F</h5>
                    </div>

                    <!--Pagination-->
                    <div class="pagination sm justify-content-left mt-5"><!--white-->
                        <button class="page-link active"><!--active -->
                            <img src="/icons/icon-pagination-prev.svg" class="pagination-icon" alt="" />
                            Précedent
                        </button>
                        <button class="page-link active">1</button>
                        <button class="page-link">2</button>
                        <button class="page-link">3</button>
                        <button class="page-link pl-4">
                            Suivant
                            <img src="/icons/icon-pagination-next.svg" class="pagination-icon ml-2" alt="" />
                        </button>
                    </div>
                    <!---->
                </div>

                <div class="s2 flex-center"><hr class="hr-vertical h-500" /></div>

                <div class="s10 px-4 mt-2">
                    <img src="/images/graph-transaction.png" alt="Transaction Graph" width="100%" />

                    <div class="clear-both h-30"></div>

                    <div class="grid2">
                        <div class="mb-4">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-color-1000"></div>
                                Achat Supermarché
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">184 350 F</h1>
                            <div class="h-25 mt-3 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" style="width: 92%;">
                                    92%
                                </div>
                            </div>
                        </div>
                        <div class="mb-4">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-purple"></div>
                                Utilisation
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">52 350 F</h1>
                            <div class="h-25 mt-3 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" style="width: 92%;">
                                    92%
                                </div>
                            </div>
                        </div>
                        <div class="mb-4">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-color-1000"></div>
                                Achat Supermarché
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">184 350 F</h1>
                            <div class="h-25 mt-3 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" style="width: 92%;">
                                    92%
                                </div>
                            </div>
                        </div>
                        <div class="mb-4">
                            <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                                <div class="circle-medium bg-purple"></div>
                                Utilisation
                            </h5>
                            <h1 class="secondary-font font-semibold text-grey-900 my-2">52 350 F</h1>
                            <div class="h-25 mt-3 rounded-100 position-relative overflow-hidden" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                <div class="h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white" style="width: 92%;">
                                    92%
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="clear-both h-50"></div>

    </section>
</template>